import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery, transformApiError } from '../../utils/createAuthBaseQuery';
import { API_URLS } from '../../constants/apiUrl';

export interface UpdateAlternativeMatchingRequest{
    matchingId: number;
    isMatching: boolean;
    oldMotorId?: number;
}

export interface UpdateAlternativeMatchingResponse{
    success: boolean;
    message: string;
}

const BASE_URL = process.env.REACT_APP_MOTER_SERVICE_API_BASE_URL as string;    

if (!BASE_URL) {
  throw new Error('REACT_APP_MOTER_SERVICE_API_BASE_URL is not defined in the environment variables');
}

const baseQuery = createBackendBaseQuery(BASE_URL);

export const comparisonReportMatchNoMatchApiSlice = createApi({
  reducerPath: 'comparisonReportMatchNoMatchApi',
  baseQuery: baseQuery,
  tagTypes: ['MatchedAlternative'],
  endpoints(builders) {
    return {
      postAlternativeMatching: builders.mutation<UpdateAlternativeMatchingResponse, UpdateAlternativeMatchingRequest>({
        query: ({ matchingId, isMatching, oldMotorId }) => ({
           url: `${API_URLS.MOTOR_INVESTIGATION.MATCH_NO_MATCH}?motorInvestigationFlowAlternativeId=${matchingId}&isMatched=${isMatching}&oldMotorId=${oldMotorId}`,
          method: 'POST',
          body: { matchingId, isMatching, oldMotorId },
        }),
        invalidatesTags: ['MatchedAlternative'],
        transformErrorResponse: transformApiError,
      }),
    };
},
});

export const { usePostAlternativeMatchingMutation } = comparisonReportMatchNoMatchApiSlice;
